module.exports = __webpack_public_path__ + "media/src/img/payment/kg_qrcode-54dd9faf082cd3eca9da76525b060d79.jpeg";